import React from "react";
import Barcode from "react-barcode";
import moment from "moment";
import { formatDecimal, lsGet } from "../../../../../hooks/Method";

const PrintQuoteReceipt = ({ data }) => {
  const activeReg = lsGet("activeReg");

  return (
    <div style={{ marginTop: "20px", marginBottom: "20px" }}>
      <div
        style={{
          fontFamily: "Arial, sans-serif",
          maxWidth: "400px",
          margin: "0 auto",
          padding: "20px",
          border: "1px solid #ddd",
          display: "grid",
        }}
      >
        {/* Header  */}
        {activeReg && activeReg.outlet && (
          <div
            style={{
              display: "grid",
              gap: "5px",
              textAlign: "center",
              justifyContent: "center",
            }}
          >
            <span
              style={{
                fontSize: "26px",
                fontWeight: "bold",
                textTransform: "uppercase",
              }}
            >
              Sell Receipt
            </span>
            <span style={{ fontSize: "20px", fontWeight: "400" }}>
              {activeReg.outlet.outletName}
            </span>
            <span>{activeReg.outlet.address1}</span>
            {activeReg.outlet.address2 && (
              <span>{activeReg.outlet.address2}</span>
            )}
            <span>
              {activeReg.outlet.city}, {activeReg.outlet.state}{" "}
              {activeReg.outlet.zip}
            </span>
            <span>Tell: {activeReg.outlet.phone}</span>
          </div>
        )}

        {/* Cashier Details */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "20px",
            borderBottom: "2px solid #ddd",
          }}
        >
          <div>
            <p style={{ fontWeight: "400" }}>
              Cashier:{" "}
              {activeReg &&
                activeReg.regOpenCashier &&
                activeReg.regOpenCashier.firstName +
                  " " +
                  activeReg.regOpenCashier.lastName}
            </p>
          </div>
          <div style={{ display: "grid", gap: "5px" }}>
            <span style={{}}>
              Date: {moment(data.sellDate).format("ddd, DD MMM YYYY")}
            </span>
            <span style={{}}>
              Time: {moment(data.sellDate).format("hh:mm A")}
            </span>
          </div>
        </div>

        {/* Customer Details */}
        <div
          style={{
            gap: "2px",
            marginTop: "5px",
            borderBottom: "2px solid #ddd",
          }}
        >
          <p style={{ fontWeight: "400" }}>
            Customer:{" "}
            {data &&
              data.customer &&
              data.customer.firstName + " " + data.customer.lastName}
          </p>
          <p style={{ fontWeight: "400", fontSize: "14px" }}>
            <span style={{ fontWeight: "bold" }}>Note: </span>
            {data && data.note}
          </p>
        </div>

        <table
          style={{
            width: "100%",
            marginTop: "10px",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  paddingBottom: "15px",
                  textTransform: "uppercase",
                }}
              >
                Item
              </th>
              <th
                style={{
                  textAlign: "right",
                  paddingBottom: "15px",
                  textTransform: "uppercase",
                }}
              >
                Price
              </th>
            </tr>
          </thead>
          <tbody>
            {data.quoteItems.map((item, ind) => (
              <tr
                key={ind}
                style={{
                  borderBottom: `${
                    data.quoteItems.length !== ind + 1
                      ? "1px solid #ddd"
                      : "none"
                  }`,
                }}
              >
                <td
                  style={{
                    maxWidth: "180px",
                    padding: "5px 0px",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gap: "3px",
                    }}
                  >
                    {/* Product Name */}
                    <span style={{ fontSize: "14px", fontWeight: "400" }}>
                      {item.prod.name}
                    </span>
                    {/* Product Variant Name */}
                    <span style={{ fontSize: "12px", fontWeight: "400" }}>
                      Qty: {item.qty}
                      {item.varProd &&
                        ` | ${item.varProd.attrVal1} ${
                          item.varProd.attrVal2 && " / " + item.varProd.attrVal2
                        } ${
                          item.varProd.attrVal3 && " / " + item.varProd.attrVal3
                        }`}
                    </span>
                  </div>
                </td>
                <td
                  style={{
                    textAlign: "right",
                    padding: "5px 0px",
                  }}
                >
                  <span style={{ marginBottom: "5px" }}>
                    $ {formatDecimal(item.qty * item.price)}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ borderBottom: "3px solid #8f8f8f", marginTop: "10px" }} />
        <div
          style={{
            marginTop: "15px",
            display: "flex",
            justifyContent: "space-between",
            grid: "10px",
            textTransform: "uppercase",
          }}
        >
          {/* Label */}
          <div style={{ display: "grid", gap: "10px", color: "#6f6f6f" }}>
            <span style={{ display: "flex", itemAlign: "center" }}>
              Total
              <span
                style={{
                  fontSize: "14px",
                  marginLeft: "10px",
                  textTransform: "lowercase",
                  fontWeight: "bold",
                }}
              >
                ({data.totalItem} items)
              </span>
            </span>
            <span>Tax ({data.taxRate}%)</span>
            <span>Discount</span>
            <span style={{ fontWeight: "bold", fontSize: "18px" }}>To Pay</span>
          </div>

          {/* Value */}
          <div style={{ display: "grid", gap: "5px", color: "#6f6f6f" }}>
            <span>$ {formatDecimal(data.subtotal)}</span>
            <span> $ {formatDecimal(data.taxAmt)}</span>
            <span>(-) $ {formatDecimal(data.disAmt)}</span>
            <span style={{ fontWeight: "bold", fontSize: "18px" }}>
              $ {formatDecimal(data.totalPay)}
            </span>
          </div>
        </div>

        <div style={{ borderBottom: "3px solid #bfbfbf", marginTop: "10px" }} />
        <div
          style={{
            paddingTop: "15px",
            paddingBottom: "5px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Barcode value={data.id.toString()} />
        </div>

        <div style={{ borderBottom: "3px solid #bfbfbf", marginTop: "10px" }} />
        <p
          style={{
            textAlign: "center",
            marginTop: "20px",
            fontSize: "22px",
            fontWeight: "bold",
            color: "#6f6f6f",
            textTransform: "uppercase",
            letterSpacing: "5px",
          }}
        >
          * Thank you *
        </p>
      </div>
    </div>
  );
};

export default PrintQuoteReceipt;
